import React, { useRef, useState } from "react";
import { useEffect } from "react";

import ColorPicker from "./colorPicker";

export default function ColorEditor({ colorEditorPos, width, colorRef, gridBackground, gridText, hover, hideIcon }) {
  const [isActive, setIsActive] = useState(false);

  const handleOpen = () => {
    setIsActive(true);
  };

  const handleClose = () => {
    setIsActive(false);
  };

  return (
    <div className="text_editor_item text-background-color d-flex mr-4" onClick={handleOpen} ref={colorRef}
    id={hideIcon ? 'icon-hidden' : ''} >
      <div className="icon mr-3 d-flex">
        <img src="/assets/icons/color-select.svg" />
      </div>
      <ColorPicker isActive={isActive}
        handleOpen={handleOpen}
        handleClose={handleClose}
        colorEditorPos={colorEditorPos}
        width={width}
        gridBackground={gridBackground}
        gridText={gridText}
        hover={hover} />
    </div>
  );
}
